import { Tooltip } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

/**
 * Shared styles for consistent widget appearance
 */
export const inputStyles = {
  "& .MuiOutlinedInput-root": {
    backgroundColor: "background.paper",
    transition: "all 0.2s ease-in-out",
    "&:hover": {
      backgroundColor: "action.hover",
    },
    "&.Mui-focused": {
      backgroundColor: "background.paper",
    },
  },
  "& .MuiInputLabel-root": {
    fontSize: "0.875rem",
  },
};

/**
 * Creates a label with optional required indicator
 * Also converts PascalCase to Spaced Case
 */
export const renderLabel = (label: string | undefined, required: boolean) => {
  if (!label) return "";
  
  // Convert PascalCase/camelCase to Spaced Case (e.g., "HowReported" -> "How Reported")
  const formattedLabel = label
    .replace(/([A-Z])/g, " $1")
    .replace(/^./, (str) => str.toUpperCase())
    .trim();
    
  return required ? `${formattedLabel} *` : formattedLabel;
};

/**
 * Renders a tooltip with description if provided
 */
export const renderDescriptionTooltip = (description?: string) => {
  if (!description) return null;
  return (
    <Tooltip title={description} arrow placement="top">
      <InfoOutlinedIcon
        fontSize="small"
        sx={{ cursor: "help", color: "action.active", ml: 1 }}
      />
    </Tooltip>
  );
};
